<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- ime -->
      <div class="columns">
        <div class="column has-text-centered"><label>Zaposleni:</label></div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            :disabled="isEmployeeChangeDisabled"
            type="text"
            label="name"
            :clearable="false"
            :options="employees"
            v-model="selectedEmployee"
          />
        </div>
      </div>
      <!-- Status -->
      <div class="columns">
        <div class="column has-text-centered"><label>Status:</label></div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :clearable="false"
            :options="listboxStatuses"
            v-model="selecteListboxdStatus"
          />
        </div>
      </div>
      <!-- opis -->
      <div class="columns">
        <div class="column">
          <input
            class="input has-text-centered has-background-info-light"
            type="text"
            placeholder="opis"
            v-model="selectedAbsence.note"
          />
        </div>
      </div>
      <!-- Startno i završno vrijeme -->
      <div class="columns">
        <!-- Startno vrijeme -->
        <div class="column">
          <date-picker
            v-model="startDate"
            @change="startDateChanged"
            type="date"
            placeholder="Početak"
          ></date-picker>
        </div>
        <!-- Završno vrijeme -->
        <div class="column">
          <date-picker
            v-model="endDate"
            type="date"
            placeholder="Kraj"
            :disabled-date="disabledYesterdayAndBefore"
          ></date-picker>
        </div>
      </div>
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            :disabled="isSaveDisabled"
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            :disabled="isSaveDisabled"
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
const { DateTime } = require("luxon");

export default {
  name: "EditAbsence",

  components: {
    DatePicker,
  },

  computed: {
    isSaveDisabled() {
      // you can  check your form is filled or not here.
      if (
        this.selectedEmployee !== null &&
        this.selecteListboxdStatus !== null &&
        this.startDate !== null &&
        this.endDate !== null
      ) {
        return false;
      } else return true;
    },
  },

  props: {
    button1Name: String,
    button2Name: String,
    title: String,
    selectedAbsence: Object,
    statuses: Array,
    employees: Array,
    departments: Array,
    isEmployeeChangeDisabled: Boolean,
    isSaveAndProceedButtonVisible: Boolean,
  },

  data() {
    return {
      selectedEmployee: null,
      listboxStatuses: [],
      selecteListboxdStatus: null,
      startDate: null,
      endDate: null,
      oldStartDate: null,
      oldEndDate: null,
      oldStatusId: null,
    };
  },

  mounted() {
    console.log("mounted");
    this.selectedAbsence.companyId = this.$store.state.general.companyId;
    this.arrangeStatuses();

    if (!this.selectedAbsence.isnew) {
      this.selectedEmployee = this.employees.find(
        (e) => e.id == this.selectedAbsence.employeeId
      );

      this.selecteListboxdStatus = this.listboxStatuses.find(
        (s) => s.id == this.selectedAbsence.statusId
      );

      console.log(this.selectedAbsence.startDate);

      this.oldStartDate = this.selectedAbsence.startDate;
      this.oldEndDate = this.selectedAbsence.endDate;
      this.oldStatusId = this.selectedAbsence.statusId;

      this.startDate = new Date(this.selectedAbsence.startDate);

      this.endDate = new Date(this.selectedAbsence.endDate);
    }
  },

  methods: {
    startDateChanged(date) {
      console.log(date);
    },

    disabledYesterdayAndBefore(date) {
      const today = new Date(this.startDate);
      today.setHours(0, 0, 0, 0);

      return date < today;
    },

    saveAndProceedButtonClicked() {
      this.calculateEmployee();
      this.$emit("saveAndProceedClicked", {
        abs: this.selectedAbsence,
        oldStartDate: this.oldStartDate,
        oldEndDate: this.oldEndDate,
      });
      console.log(this.selectedAbsence);
    },
    saveAndCloseButtonClicked() {
      this.calculateEmployee();
      this.$emit("saveAndCloseClicked", {
        abs: this.selectedAbsence,
        oldStartDate: this.oldStartDate,
        oldEndDate: this.oldEndDate,
        oldStatusId: this.oldStatusId,
      });
      console.log(this.selectedAbsence);
    },
    arrangeStatuses() {
      this.statuses.forEach((sts) => {
        this.listboxStatuses.push({
          id: sts.statusId,
          name: sts.code + sts.description,
        });
      });
    },
    calculateEmployee() {
      this.selectedAbsence.statusId = this.selecteListboxdStatus.id;
      this.selectedAbsence.startDate = this.startDate;
      console.log("hic22!!");
      console.log(this.startDate);
      var luxonStartDate = DateTime.fromJSDate(this.startDate);
      var luxonEndDate = DateTime.fromJSDate(this.endDate);
      var start = luxonStartDate.toISO().split("T")[0];
      var end = luxonEndDate.toISO().split("T")[0];
      this.selectedAbsence.startDate = start;
      this.selectedAbsence.endDate = end;
      this.selectedAbsence.employeeId = this.selectedEmployee.id;
    },
  },
};
</script>
